import {
  IonBackButton, IonButtons, IonContent,
  IonHeader,
  IonPage, IonTitle, IonToolbar
} from "@ionic/react";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { findDocuments } from "../../store/locationShow/actions/findDocuments";
import { findLocation } from "../../store/locationShow/actions/findLocation";
import { findMessages } from "../../store/locationShow/actions/findMessages";
import { findMultipleFormsSubmitted } from "../../store/locationShow/actions/findMultipleFormsSubmitted";
import { findUserRoles } from "../../store/locationShow/actions/findUserRoles";
import { HeaderSection } from "./components/HeaderSection";
import { LoadingSection } from "./components/LoadingSection";
import { SegmentsSection } from "./components/SegmentsSection";
import {findLocationDocuments} from "../../store/locationShow/actions/findLocationDocuments"

export const SupervisorLocationShow: React.FC = () => {
  const dispatch = useDispatch();

  const { id }: { id: string } = useParams();

  useEffect(() => {
    dispatch(findLocation(id));
    dispatch(findUserRoles(id));
    dispatch(findMessages(id));
    dispatch(findDocuments(id));
    dispatch(findLocationDocuments(id));
    //dispatch(findMultipleFormsSubmitted(id));
  }, [dispatch, id]);

  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton color="light" defaultHref="/app/supervision" />
          </IonButtons>
          <IonTitle>Instalación</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <LoadingSection />
        <HeaderSection />
        <SegmentsSection />
      </IonContent>
    </IonPage>
  );
};
